var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGridIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M15.082 12.805h5.325v3.036c-.697.61-1.927 1.19-3.545 1.19-3.24 0-5.098-2.251-5.098-6.177 0-3.746 1.893-5.982 5.07-5.982 1.763 0 3.207.475 4.55 1.496l.708.538 2.331-3.063-.653-.524C22.434 2.24 20.438 1 16.848 1 11.256 1 7.5 4.984 7.5 10.914 7.5 18.358 12.414 21 16.623 21c3.177 0 5.9-1.126 7.668-3.17l.209-.24V9.113h-9.418v3.691z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#00CDF6",
  strokeWidth: 1.5,
  d: "M8.25 25.75h15.5v4.5H8.25v-4.5z"
})));
export default SvgGridIcon;